import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum FormTemplatesCacheEvents {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

// form templates are used across projects, and even across orgs,
// so the invalidation here isn't specific to either.
type CacheParams = Record<string, never>;

const cacheRegister = initCacheInvalidatorRegister<
  typeof FormTemplatesCacheEvents,
  CacheParams
>(FormTemplatesCacheEvents);

export const invalidateFormTemplatesCache = cacheRegister.invalidate;
export const formTemplatesCacheRegister = cacheRegister.register;
